<template>
  <b-modal :visible="visible" @hide="$emit('close')" title="Подвести итоги предикта" size="md">
    <p class="mb-3">Выберите команду-победителя:</p>
    <b-form-select v-model="selectedTeamId" :options="teamOptions"></b-form-select>

    <template #modal-footer>
      <b-button variant="secondary" @click="$emit('close')">Отмена</b-button>
      <b-button variant="primary" @click="onConfirm" :disabled="!selectedTeamId">Подтвердить</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "PredictionResolveModal",
  props: {
    visible: { type: Boolean, default: false },
    teams: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedTeamId: null,
    }
  },
  computed: {
    teamOptions() {
      return [
        { value: null, text: 'Выберите победителя' },
        ...this.teams.map(t => ({ value: t.id, text: t.name || `Команда #${t.id}` }))
      ];
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedTeamId = null;
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('resolve', this.selectedTeamId);
    }
  }
}
</script>
